import { Step } from '../stepper';

export const skewLines = (items: Step[], index: number) => {
  const isCurrentStepSubStep = items[index]?.isSubStep;
  const isNextStepSubStep = items[index + 1]?.isSubStep;

  if (!isCurrentStepSubStep && isNextStepSubStep) {
    return 'skew(20deg)';
  } else if (isCurrentStepSubStep && !isNextStepSubStep) {
    return 'skew(-20deg)';
  } else {
    return 'skew(0deg)';
  }
};
